import React, { useEffect, useState } from 'react'
import { CgShoppingCart } from 'react-icons/cg'
import {
  withRouter,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import { articlesApi } from '../../../api/articlesApi'
import {
  presentationProductsApi,
  presentationsApi,
} from '../../../api/presentationsApi'
import { routes } from '../../../constantes/routes'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalLoading,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import Header from '../../header/Header'
import ProductsPresentationList from '../edit-presentation/ProductsPresentationList'
import FinalProductContainer from '../../final-product/FinalProductConainer'
import SendBtn from '../../buttons/SendBtn'
import { presentationsActions } from '../../../actions/presentationsActions'
import { swalTitle } from '../../../constantes/swalTitle'
import { useDispatch, useSelector } from 'react-redux'
import { Footer } from '../../common/Footer'

const ViewPresentationContainer = () => {
  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()

  const [namePresentation, setNamePresentation] = useState('')
  const [allPresentationProducts, setAllPresentationProducts] = useState([])
  const [cartItemsCounter, setCartItemsCounter] = useState(0)
  const [isfinalProductView, setFinalProductView] = useState(false)
  const [itemSelected, setItemSelected] = useState('')
  const [isDisabled, setIsDisabled] = useState(false)
  const [presentation, setPresentation] = useState(null)
  const userProfile = useSelector((state) => state.userProfile)
  const presentationsState = useSelector((state) => state.presentations)

  useEffect(() => {
    const presentationFiltered = presentationsState.filter(
      (presentation) => presentation.id_Presentacion === parseInt(id),
    )
    setPresentation(presentationFiltered[0])
  }, [presentationsState, id])

  useEffect(() => {
    getPresentationById(id)
  }, [isfinalProductView, id])

  const getPresentationById = async (getPresentationById) => {
    try {
      const response =
        await presentationProductsApi.getInfoProductsPresentationById(
          getPresentationById,
        )
      if (response.data) {
        // console.log('response.data', response.data)
        setNamePresentation(response.data.nombre)
        setCartItemsCounter(response.data.numeroProductosPresentacion)
        setAllPresentationProducts(response.data.productos)
      }
    } catch (error) {
      history.push(routes.PRESENTATION)
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const goToViewDetailProduct = async (idArticle) => {
    const resp = await articlesApi.getInfoArticle(idArticle)
    if (resp.data) {
      setItemSelected(resp.data)
    }
    setFinalProductView(true)
  }

  const goBack = () => {
    isfinalProductView
      ? history.push(routes.PRESENTATION_VIEW + id)
      : history.push(routes.PRESENTATION)
    setFinalProductView(false)
  }

  const handleSendPresentationToContact = async (id_ContactoPresentacion) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres enviar la presentación?',
      )
      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        setIsDisabled(true)
        const response = await dispatch(
          presentationsActions.sendPresentationToContact(
            id_ContactoPresentacion,
          ),
        )
        if (response.payload) {
          swalSuccessGeneral(swalTitle.Enviado, response.payload.mssg)
        }
        setIsDisabled(false)
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisabled(false)
    }
  }
  const canEditDeleteSendPresentation = (presentation) => {
    return presentation.id_Usuario === userProfile.id_Usuario
  }

  return (
    <div className='products'>
      <Header text={'Ver presentación'} route={goBack} backBtn={true} />

      <div className='filter__wrap-left mb-80'>
        <h4 className='product-title' style={{ textTransform: 'inherit' }}>
          Productos de {namePresentation}
        </h4>
        <div>
          <span className='btn-add-shopping'>
            <span className='cart-counter'>{cartItemsCounter}</span>
            <span>
              <CgShoppingCart className='green-btn-plus cart-btn' />
            </span>
          </span>
          {presentation?.presentacionContacts?.length > 0 ? (
            canEditDeleteSendPresentation(presentation) &&
            presentation?.presentacionContacts[0]?.isActive ? (
              <button
                style={{
                  position: 'absolute',
                  right: '192px',
                  top: '235px',
                }}
                disabled={isDisabled}
                onClick={() => {
                  if (presentation?.presentacionContacts[0]) {
                    handleSendPresentationToContact(
                      presentation?.presentacionContacts[0]
                        ?.id_ContactoPresentation,
                    )
                  }
                }}
              >
                <SendBtn />
              </button>
            ) : null
          ) : null}
        </div>
      </div>
      {isfinalProductView ? (
        <div className='frameless'>
          <FinalProductContainer
            item={itemSelected}
            onlyViewDocsProduct={true}
            idPresentation={id}
          />
        </div>
      ) : (
        <div className='products__cards-list-wrapper'>
          <ProductsPresentationList
            allPresentationProducts={allPresentationProducts}
            goToViewDetailProduct={goToViewDetailProduct}
            isEditPresentation={false}
          />
        </div>
      )}
      <Footer />
    </div>
  )
}

export default withRouter(ViewPresentationContainer)
